import type { Outline } from "../math/samplePath";

/** A single, original closed dragon silhouette. No inner strokes or pen lifts. */
type XY = readonly [number, number];
const start: XY = [92, 158];
// Cubics run from the muzzle, over the horns and spine, out to the flame tail,
// then along the belly and two clawed feet back to the open mouth.
const segments: readonly (readonly [XY, XY, XY])[] = [
  [
    [108, 144],
    [133, 142],
    [153, 139],
  ],
  [
    [165, 124],
    [181, 121],
    [193, 116],
  ],
  [
    [205, 91],
    [217, 65],
    [243, 45],
  ],
  [
    [231, 78],
    [229, 99],
    [231, 107],
  ],
  [
    [250, 98],
    [270, 81],
    [287, 68],
  ],
  [
    [278, 95],
    [263, 119],
    [244, 135],
  ],
  [
    [263, 141],
    [273, 151],
    [280, 163],
  ],
  [
    [299, 158],
    [310, 147],
    [317, 141],
  ],
  [
    [313, 160],
    [307, 174],
    [296, 183],
  ],
  [
    [326, 197],
    [349, 217],
    [359, 243],
  ],
  [
    [375, 240],
    [387, 235],
    [398, 224],
  ],
  [
    [393, 248],
    [382, 260],
    [369, 267],
  ],
  [
    [374, 289],
    [371, 311],
    [360, 333],
  ],
  [
    [377, 334],
    [392, 330],
    [405, 324],
  ],
  [
    [393, 345],
    [375, 354],
    [349, 359],
  ],
  [
    [322, 392],
    [296, 419],
    [307, 447],
  ],
  [
    [320, 481],
    [359, 480],
    [388, 452],
  ],
  [
    [420, 421],
    [429, 360],
    [470, 334],
  ],
  [
    [505, 307],
    [552, 317],
    [584, 356],
  ],
  [
    [600, 353],
    [613, 342],
    [620, 332],
  ],
  [
    [621, 350],
    [615, 370],
    [608, 382],
  ],
  [
    [630, 416],
    [666, 424],
    [689, 399],
  ],
  [
    [720, 365],
    [711, 330],
    [696, 302],
  ],
  [
    [674, 262],
    [684, 219],
    [710, 194],
  ],
  [
    [699, 223],
    [699, 242],
    [707, 253],
  ],
  [
    [716, 224],
    [741, 215],
    [750, 182],
  ],
  [
    [773, 226],
    [751, 257],
    [729, 276],
  ],
  [
    [746, 271],
    [760, 262],
    [768, 253],
  ],
  [
    [765, 280],
    [747, 299],
    [726, 309],
  ],
  [
    [750, 360],
    [756, 402],
    [731, 445],
  ],
  [
    [709, 484],
    [672, 494],
    [637, 483],
  ],
  [
    [638, 501],
    [658, 511],
    [675, 516],
  ],
  [
    [652, 523],
    [632, 519],
    [619, 510],
  ],
  [
    [621, 528],
    [636, 540],
    [645, 545],
  ],
  [
    [618, 545],
    [599, 529],
    [598, 509],
  ],
  [
    [594, 494],
    [588, 480],
    [577, 467],
  ],
  [
    [550, 440],
    [543, 398],
    [515, 393],
  ],
  [
    [489, 389],
    [470, 426],
    [460, 452],
  ],
  [
    [445, 491],
    [426, 524],
    [399, 543],
  ],
  [
    [402, 559],
    [419, 568],
    [435, 571],
  ],
  [
    [420, 581],
    [402, 581],
    [388, 574],
  ],
  [
    [389, 590],
    [402, 600],
    [412, 605],
  ],
  [
    [384, 607],
    [363, 594],
    [361, 577],
  ],
  [
    [326, 586],
    [284, 578],
    [254, 552],
  ],
  [
    [237, 569],
    [216, 578],
    [194, 574],
  ],
  [
    [210, 566],
    [220, 555],
    [224, 542],
  ],
  [
    [207, 548],
    [190, 547],
    [178, 541],
  ],
  [
    [195, 536],
    [207, 527],
    [216, 514],
  ],
  [
    [190, 470],
    [193, 425],
    [217, 389],
  ],
  [
    [240, 354],
    [277, 326],
    [282, 288],
  ],
  [
    [287, 255],
    [275, 228],
    [251, 210],
  ],
  [
    [230, 218],
    [212, 224],
    [191, 223],
  ],
  [
    [174, 243],
    [157, 256],
    [140, 256],
  ],
  [
    [150, 247],
    [155, 239],
    [158, 230],
  ],
  [
    [144, 233],
    [129, 237],
    [117, 233],
  ],
  [
    [136, 221],
    [148, 209],
    [156, 195],
  ],
  [
    [141, 188],
    [122, 178],
    [105, 174],
  ],
  [
    [107, 181],
    [108, 190],
    [111, 195],
  ],
  [
    [100, 190],
    [94, 182],
    [89, 176],
  ],
  [
    [92, 188],
    [81, 186],
    [73, 180],
  ],
  [
    [70, 170],
    [79, 162],
    [92, 158],
  ],
];
export const dragonSingle: Outline = segments.map((s, i) => ({
  from: {
    x: (i ? segments[i - 1][2] : start)[0],
    y: (i ? segments[i - 1][2] : start)[1],
  },
  c1: { x: s[0][0], y: s[0][1] },
  c2: { x: s[1][0], y: s[1][1] },
  to: { x: s[2][0], y: s[2][1] },
}));
